import { Alert } from 'react-bootstrap';
import ResourceCrudWorkspace from './resource-crud-workspace';
import EvidenceReviewWorkspace from './evidence-review-workspace';
import GroupLocationWorkspace from './group-location-workspace';
import GroupServiceWorkspace from './group-service-workspace';
import GroupPeopleWorkspace from './group-people-workspace';
import { SharedScopeWorkspace } from './shared-scope-workspace';

type Domain = 'locations' | 'services' | 'providers' | 'roles-shifts';

const reviewKinds = {
  locations: 'location',
  services: 'service',
  providers: 'provider',
  'roles-shifts': 'role_shift',
} as const;

export default function StructureRosterWorkspace({ tenantQuery, initialDomain = 'locations', onPendingChange, onDirtyChange }: {
  tenantQuery: string;
  initialDomain?: Domain;
  onPendingChange: (count: number) => void;
  onDirtyChange: (dirty: boolean) => void;
}) {
  const domain = initialDomain;
  const editableResource = domain === 'roles-shifts' ? null : domain;

  return <div className="d-flex flex-column gap-3">
    <div aria-live="polite">
      {domain === 'locations'
        ? <GroupLocationWorkspace tenantQuery={tenantQuery} reviewWorkspace={({ locations, loading, busyRecordId, deleteConfirmId, addLocation, editLocation, deleteLocation }) => <EvidenceReviewWorkspace
            kind="location"
            tenantQuery={tenantQuery}
            canonicalLocations={locations}
            canonicalLoading={loading}
            canonicalBusyId={busyRecordId}
            canonicalDeleteConfirmId={deleteConfirmId}
            onAddCanonicalLocation={addLocation}
            onEditCanonical={editLocation}
            onDeleteCanonical={deleteLocation}
            onPendingChange={onPendingChange}
            onDirtyChange={onDirtyChange}
          />} />
        : domain === 'services'
        ? <GroupServiceWorkspace tenantQuery={tenantQuery} reviewWorkspace={({ services, loading, busyRecordId, deleteConfirmId, editService, deleteService, addService, locationOptions }) => <EvidenceReviewWorkspace
            kind="service"
            tenantQuery={tenantQuery}
            canonicalServices={services}
            canonicalServicesLoading={loading}
            canonicalServiceBusyId={busyRecordId}
            canonicalServiceDeleteConfirmId={deleteConfirmId}
            onEditCanonicalService={editService}
            onDeleteCanonicalService={deleteService}
            onAddCanonicalService={addService}
            serviceLocationOptions={locationOptions}
            onPendingChange={onPendingChange}
            onDirtyChange={onDirtyChange}
          />} />
        : domain === 'providers'
        ? <GroupPeopleWorkspace tenantQuery={tenantQuery} reviewWorkspace={({ people, loading, busyRecordId, deleteConfirmId, addPerson, editPerson, deletePerson }) => <EvidenceReviewWorkspace
            kind="provider"
            tenantQuery={tenantQuery}
            canonicalPeople={people}
            canonicalPeopleLoading={loading}
            canonicalPersonBusyId={busyRecordId}
            canonicalPersonDeleteConfirmId={deleteConfirmId}
            onAddCanonicalPerson={addPerson}
            onEditCanonicalPerson={editPerson}
            onDeleteCanonicalPerson={deletePerson}
            onPendingChange={onPendingChange}
            onDirtyChange={onDirtyChange}
          />} />
        : editableResource
        ? <ResourceCrudWorkspace key={domain} resource={editableResource} tenantQuery={tenantQuery} />
        : null}
      {domain !== 'locations' && domain !== 'services' && domain !== 'providers' ? <EvidenceReviewWorkspace key={domain} kind={reviewKinds[domain]} tenantQuery={tenantQuery} onPendingChange={onPendingChange} onDirtyChange={onDirtyChange} /> : null}
      {domain === 'locations' ? <SharedScopeWorkspace tenantQuery={tenantQuery} entityType="location" /> : null}
      {domain === 'services' ? <SharedScopeWorkspace tenantQuery={tenantQuery} entityType="service" /> : null}
      {domain === 'roles-shifts' ? <SharedScopeWorkspace tenantQuery={tenantQuery} entityType="role_shift" /> : null}
    </div>
    {domain === 'providers' && <Alert variant="warning" className="mb-0"><strong>Identity is not schedulability.</strong> Adding or approving a person does not grant department membership, eligibility, targets, scheduling access, or activation.</Alert>}
  </div>;
}
